/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 *
 * @package Mercury
 * @copyright 2021 National Residential Landlords Association
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

//==============================================================================

//
module.exports = function(template, data) {
    var template_name = 'zeno-template-cache-' + template;
    if (typeof (window[template_name]) == 'undefined') {
        window[template_name] = zeno_prepare_template(document.getElementById(template).innerHTML);
    }
    return window[template_name](data || {});
}

//==============================================================================

//store all the callbacks that we want to use as filters
window.zeno_filter_callbacks = {}; //!!!

//add a function to allow adding of new filters
function zeno_template_add_filter(name, callback) {
    if (typeof callback === 'function') {
        zeno_filter_callbacks[name] = callback;
    }
}

//==============================================================================

//declare some basic filters
zeno_template_add_filter('upper', function(value) {
    return ((value !== null) ? value.toUpperCase() : '');
});

zeno_template_add_filter('lower', function(value) {
    return ((value !== null) ? value.toLowerCase() : '');
});

zeno_template_add_filter('title', function(value) {
    return ((value !== null) ? value.toTitleCase() : '');
});

//twig like replace filter
zeno_template_add_filter('replace', function(haystack, replacements) {
    for (const [needle, value] of Object.entries(replacements)) {
        haystack = haystack.replace(needle, value);
    }
    return haystack;
});

zeno_template_add_filter('default', function(value, ifnull) {
    return ((value == '') ? ifnull : value);
});

zeno_template_add_filter('number_format', function(value, precision, zero_value) {
    if (value === null || isNaN(value) || value == 0) {
        return ((typeof zero_value !== 'undefined') ? zero_value : null);
    }
    return parseInt(value, 10).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ((parseInt(precision, 10) > 0) ? ((value.toFixed(precision).slice(-(precision + 1))) || '.' + ('0'.repeat(precision))) : '')
});

//==============================================================================

/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 * @param  {string} template Required - The id of the template to render
 * @param  {object} data     Optional - The data to pass into the template renderer
 * @return {string}
 */
function zeno_prepare_template(template) {

    //remove any whitespace characters inside our [[ and ]] operators
    template = template.replace(/\[\[(\s+)/g, "[[");
    template = template.replace(/(\s+)\]\]/g, "]]");

    //allow the user to set variables for use later in the template
    template = template.replace(/\[\[set (.+)\]\]/g, "[[var $1;]]");

    //pre-parse some common commands into "native" template language
    template = template.replace(/\[\[if([^{]+?)\]\]/g, "[[ if ($1) { ]]"); // "[^{]" vs "." to prevent it from parsing the legacy if conditions
    template = template.replace(/\[\[else\]\]/g, "[[ } else { ]]");
    template = template.replace(/\[\[endif\]\]/g, "[[ } ]]");

    //for loops
    template = template.replace(/\[\[for ([^\(]+?) in (.+?)\]\]/g, "[[ if (typeof $2 !== 'undefined') { for (var _$1 in $2 ) { if ($2.hasOwnProperty(_$1)) { var $1 = $2[_$1], loop = {'index':_$1}; ]]");
    template = template.replace(/\[\[endfor\]\]/g, "[[ }}} ]]");

    //ternary if statements
    template = template.replace(/\[\[iif\((.+?),(.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : $3));]]");
    template = template.replace(/\[\[iif\((.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : ''));]]");

    //allow templates to be included from within other templates
    template = template.replace(/\[\[include(.+)with(.+)\]\]/g, "[[p.push(zeno_template($1, $.extend({}, data, $2)));]]");
    template = template.replace(/\[\[include(.+)\]\]/g, "[[p.push(zeno_template($1, data));]]");

    //condense any whitespace into a single space character
    template = template.replace(/[\r\t\n]/g, " ");

    //process any "echo" expressions
    template = template.replace(/\[\[=(.+?)\]\]/g, function(match, variable) {

        //process the string if it contains filters - currently only allowing 1 filter
        if ((filter = variable.match(/(.+?)\|(.+?)\((.+?)?\)/)) !== null && typeof zeno_filter_callbacks[filter[2]] == 'function') {
            return "',((typeof " + filter[1] + " !== 'undefined') ? zeno_filter_callbacks['" + filter[2] + "'](" + filter[1] + ((filter[3] != undefined) ? ', ' + filter[3] : '') + ") : ''),'";
        }

        //just a standard expression
        return "',((typeof " + variable + " !== 'undefined') ? " + variable + " : ''),'";

    });

    //
    template = template.replace(/\[\[/g, "');");
    template = template.replace(/\]\]/g, "p.push('");

    try {
        var template_callback = new Function('data', "var p = [], print = function() { p.push.apply(p, arguments); }; with(data) { p.push('" + template +  "'); } return p.join('');");
        return template_callback;
    }
    catch (exception) {
        console.error(exception);
        console.error(template);
    }

    return '';
}

//==============================================================================